'use client';
import Tag from '@/components/atoms/tag';
import {
  Box,
  //  Button,
  Container,
  Stack,
  Typography
} from '@mui/material';
import React from 'react';
import medalIcon from '/public/assets/svg/award.svg';
import Title from '@/components/atoms/title';
import Carousel from '@/components/molecules/carousel2';

const FeaturedScholarshipSection = () => {
  return (
    <Box bgcolor="white" sx={{ px: 2, py: { xs: 5, md: 7, lg: 10 } }}>
      <Container sx={{ justifyContent: 'center', display: 'flex' }}>
        <Stack sx={{ textAlign: 'center', maxWidth: 1050, pb: 2 }}>
          <Tag
            icon={medalIcon}
            sx={{ alignSelf: 'center' }}
            title="Unveiling Opportunity Down Under"
          />
          <Title title="Discover exclusive scholarship opportunities to support your master’s degree in Pakistan." />
          <Typography mt={2} variant="body1">
            {`Your master's degree, made easy! Find top scholarship opportunities and 
turn your educational goals into reality. This is your chance to study without 
financial concerns – Apply now!`}
          </Typography>
        </Stack>
      </Container>
      <Carousel />

      {/* <Button variant="contained" sx={styles.loadMoreBtn}>
        Apply Now
      </Button> */}
    </Box>
  );
};

export default FeaturedScholarshipSection;
// const styles = {
//   loadMoreBtn: { px: 10, display: 'block', mx: 'auto', mt: 5 }
// };
